import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, LREIcon } from './LREButton.styles';
import { ScrollbarWidthContext } from '../layout';
import { useMobile } from '../../hooks';

const LREButton = () => {
  const isMobile = useMobile();
  const scrollbarWidth = useContext(ScrollbarWidthContext);
  const { t } = useTranslation('menu');

  return (
    <>
<LREIcon scrollbarWidth={scrollbarWidth}>
  <a
    href="https://www.livroreclamacoes.pt/inicio"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img 
      src="/sqLRE.png" 
      alt="Livro de Reclamações" 
      width="54" 
      height="54" 
      style={{ display: 'block' }}
    />
  </a>
</LREIcon>
      {!isMobile && (
        <Tooltip scrollbarWidth={scrollbarWidth}>
          {t('Livro de Reclamações Electrónico')}
        </Tooltip>
      )}
    </>
  );
};

export default LREButton;
